// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rundeck-version-display[data-v-34ee57c5]{font-size:24px;font-weight:600;display:flex;align-content:center;align-items:center}.rundeck-version-display>i[data-v-34ee57c5]{background-size:20px;padding:0;height:20px;width:20px;margin-right:5px}", ""]);
// Exports
module.exports = exports;
